import React, { Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'reactstrap';
import MaterialTable from '../../../shared/components/material-table';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import DateField from '../../../shared/components/form/DateField';
import columnsHistoric from './ColumnsHistoric';
import materialTableIcons from '../../../shared/utils/materialTableIcons';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import { threeDecimalPlaces } from '../../../shared/components/form/Masks';
import { PAGE_SIZE } from '../../../shared/utils/constants';
import {
  measuresPropTypes,
  studentPropTypes,
} from '../../../shared/utils/SmartPropTypes';

const WeightMeasureForm = (props) => {
  const {
    t,
    handleSubmit,
    dto,
    initialize,
    backHandler,
    students,
    loadHistoricalData,
    historicalData,
    excludeDates,
  } = props;

  const onStudentChangeHandler = (student) => {
    loadHistoricalData(student.id);
  };

  const isDisabled = () => dto.id;

  useEffect(() => {
    initialize(dto);
    if (dto.student && dto.student.id) {
      loadHistoricalData(dto.student.id);
    }
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_peso_medida.student')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="student"
              type="text"
              component={SelectVirtualized}
              onChange={onStudentChangeHandler}
              placeholder={t('mnt_peso_medida.student')}
              options={students}
              isDisabled={isDisabled()}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_peso_medida.measureDate')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="measureDate"
              component={DateField}
              placeholder={t('mnt_peso_medida.measureDate')}
              maxDate={new Date()}
              excludeDates={excludeDates}
              disabled={isDisabled()}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('mnt_peso_medida.height')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="height"
                type="number"
                component={renderField}
                maxLength="10"
                placeholder={t('mnt_peso_medida.placeholders.height')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('mnt_peso_medida.weight')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="weight"
                type="text"
                component={renderField}
                maxLength="10"
                placeholder={t('mnt_peso_medida.placeholders.weight')}
                {...threeDecimalPlaces()}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('mnt_peso_medida.headDiameter')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="headDiameter"
                type="number"
                component={renderField}
                maxLength="10"
                placeholder={t('mnt_peso_medida.placeholders.headDiameter')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('mnt_peso_medida.waistCircumference')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="waistCircumference"
                type="number"
                component={renderField}
                maxLength="10"
                placeholder={t(
                  'mnt_peso_medida.placeholders.waistCircumference'
                )}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_peso_medida.history')}
          </span>
          <MaterialTable
            data={historicalData}
            icons={materialTableIcons}
            columns={columnsHistoric(t)}
            toolbar={false}
            pageSize={PAGE_SIZE.MIN}
            isFiltering
          />
        </div>
        <ButtonToolbar>
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

WeightMeasureForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  loadHistoricalData: PropTypes.func.isRequired,
  students: PropTypes.arrayOf(studentPropTypes).isRequired,
  historicalData: PropTypes.arrayOf(measuresPropTypes).isRequired,
  excludeDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
};
export default reduxForm({
  form: 'WeightMeasureForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(WeightMeasureForm));
